import React from 'react';
import { AccountTypeSelect } from '../../components/AccountTypeSelect/AccountTypeSelect';
import { InstitutionNameInput } from '../../components/InstitutionNameInput/InstitutionNameInput';
import { AccountDescription } from '../../components/AccountDescription/AccountDescription';
import { TabWrapper } from '../../AccountForm.styles';
import { FormComponentProps } from '../../AccountForm.meta';
import { TabsContent } from '../../components/TabsContent/TabsContent';
import { Balance } from '../../components/Balance/Balance';
import { AccountEarmark } from '../../components/AccountEarmark/AccountEarmark';
import { Contributions } from '../../components/Contributions/Contributions';
import { AssetBucketing } from '../../components/AssetBucketing/AssetBucketing';
import { ContributionStartYearSelect } from '../../components/ContributionStartYearSelect/ContributionStartYearSelect';
import { ContributionEndYearSelect } from '../../components/ContributionEndYearSelect/ContributionEndYearSelect';
import { Box } from '../../../../../../../../CommonComponents/OPL/Box/Box';
import { BrokerOfRecord } from '../../components/BrokerOfRecord/BrokerOfRecord';
import { Liquidity } from '../../components/Liquidity/Liquidity';
import { GrossEstateCheckbox } from '../../components/GrossEstateCheckbox/GrossEstateCheckbox';
import { ManagementStyle } from '../../components/ManagementStyle/ManagementStyle';
import { TurnoverRatio } from '../../components/TurnoverRatio/TurnoverRatio';
import { CostBasis } from '../../components/CostBasis/CostBasis';
import { DistributionStrategySelect } from '../../components/DistributionStrategy/DistributionStrategySelect';
import { AccountFees } from '../../components/AccountFees/AccountFees';
import { PercentageUsedInPlan } from '../../components/PercentageUsedInPlan/PercentageUsedInPlan';
import { LongTermCapitalGainsRatio } from '../../components/LongTermCapitalGainsRatio/LongTermCapitalGainsRatio';
import { AccountNickname } from '../../components/AccountNickname/AccountNickname';
import { AccountOwnership } from '../../components/AccountOwnership/AccountOwnership';

const Summary = () => {
  return (
    <TabWrapper>
      <AccountTypeSelect />
      <InstitutionNameInput />
      <AccountOwnership />
      <AccountDescription />
      <AccountNickname />
      <Balance />
      <AccountEarmark />
      <Contributions label="Deposits" />
      <GrossEstateCheckbox />
      <BrokerOfRecord />
      <Liquidity />
      <ManagementStyle />
      <AssetBucketing />
    </TabWrapper>
  );
};

const AccountDetails = () => {
  return (
    <TabWrapper>
      <CostBasis />
      <TurnoverRatio />

      <LongTermCapitalGainsRatio />

      <Box
        css={`
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 16px;
        `}
      >
        <ContributionStartYearSelect />
        <ContributionEndYearSelect />
      </Box>

      <DistributionStrategySelect />

      <AccountFees />

      <PercentageUsedInPlan />
    </TabWrapper>
  );
};

export const Brokerage = (props: FormComponentProps) => {
  return (
    <TabsContent
      {...props}
      tabs={[
        { name: 'Summary', Component: Summary },
        { name: 'Account Details', Component: AccountDetails },
      ]}
    />
  );
};
